// extracted by mini-css-extract-plugin
export var borderRadius = "_ew-4";
export var large = "_ew-3";
export var logoContainer = "_ew-0";
export var nameLogo = "_ew-2";
export var small = "_ew-1";